import React from 'react';
import { motion } from 'framer-motion';

const OracleFace = ({ size = 240 }) => {
  return (
    <motion.div 
      className="relative"
      style={{ width: size, height: size }}
    >
      {/* Animated glow border */}
      <motion.div
        animate={{
          boxShadow: [
            '0 0 20px rgba(0, 240, 255, 0.6), 0 0 40px rgba(0, 240, 255, 0.3)',
            '0 0 30px rgba(255, 0, 255, 0.6), 0 0 60px rgba(255, 0, 255, 0.3)',
            '0 0 20px rgba(0, 240, 255, 0.6), 0 0 40px rgba(0, 240, 255, 0.3)'
          ]
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        className="absolute inset-0 rounded-full"
        style={{
          border: '3px solid rgba(0, 240, 255, 0.8)',
          background: 'linear-gradient(135deg, rgba(0, 240, 255, 0.1), rgba(255, 0, 255, 0.1))'
        }}
      />

      {/* Oracle face image/icon - OFFICIAL PHOTO */}
      <div className="absolute inset-0 flex items-center justify-center rounded-full overflow-hidden">
        <motion.img
          src="https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/db4ebc8c931f4a929089adfc295e432f_IMG_4303.JPG"
          alt="Oracle — Jack-of-All-Trades, NextXus Federation"
          animate={{
            scale: [1, 1.02, 1]
          }}
          transition={{
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Inner glow */}
      <div 
        className="absolute inset-0 rounded-full pointer-events-none"
        style={{
          background: 'radial-gradient(circle at 30% 30%, rgba(0, 240, 255, 0.2), transparent 60%)'
        }}
      />

      {/* Online status indicator */}
      <motion.div
        animate={{
          scale: [1, 1.2, 1],
          opacity: [1, 0.7, 1]
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        className="absolute bottom-2 right-2 w-6 h-6 rounded-full bg-[#00FFA3] border-2 border-[#0B0E14]"
      />
    </motion.div>
  );
};

export default OracleFace;
